export default __webpack_public_path__ + "static/certificate-toddler-square-815a8509a7a91104cb6667f2586cf708.png";